import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-sm-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 5,
  class: "dropdown"
}
const _hoisted_8 = { class: "dropdown-menu" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 2 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 3 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 4 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 5 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 6 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 6 }
const _hoisted_24 = {
  class: "modal fade",
  id: "detailBonModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_25 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_26 = { class: "modal-content p-15 p-md-40" }
const _hoisted_27 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_center = _resolveComponent("center")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!
  const _component_DetailsNote = _resolveComponent("DetailsNote")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("label", null, "Voir", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.filters.per_page,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.per_page) = $event)),
            options: [10, 25, 50, 100],
            clearable: false,
            class: "per-page-selector d-inline-block mx-50",
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getRecords()))
          }, null, 8, ["modelValue"]),
          _createElementVNode("label", null, "sur " + _toDisplayString(_ctx.filters.total) + " entités", 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Chercher",
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter())),
            onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.searchTerm) = $event))
          }, null, 544), [
            [_vModelText, _ctx.filters.searchTerm]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows,
          loading: _ctx.isLoader
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Aucune entrées correspondantes trouvées", -1)
              ])),
              _: 1,
              __: [6]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'note_ref')
              ? (_openBlock(), _createElementBlock("b", _hoisted_6, _toDisplayString(props.row.note_ref), 1))
              : (props.column.field === 'created_at')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.getDate(props.row.created_at)), 1)
                  ], 64))
                : (props.column.field === 'note_total_parcel')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(_toDisplayString(props.row.note_total_parcel) + " Colis ", 1)
                    ], 64))
                  : (props.column.field === 'note_total_crbt')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createTextVNode(_toDisplayString(props.row.note_total_crbt) + " DH ", 1)
                      ], 64))
                    : (props.column.field === 'note_saved')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          (props.row.note_saved == 0)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass([`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
                props.row.note_saved
              )}`, "text-capitalize"])
                              }, " Nouveau ", 2))
                            : (props.row.note_saved == 1)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: _normalizeClass([`badge rounded-pill fs-13 text-bg-${_ctx.resolveUserStatusVariant(
                props.row.note_saved
              )}`, "text-capitalize"])
                                }, " Enregistré ", 2))
                              : _createCommentVNode("", true)
                        ], 64))
                      : (props.column.field === 'action')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _cache[15] || (_cache[15] = _createElementVNode("button", {
                              class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
                              type: "button",
                              "data-bs-toggle": "dropdown",
                              "aria-expanded": "false"
                            }, [
                              _createElementVNode("i", { class: "flaticon-dots" })
                            ], -1)),
                            _createElementVNode("ul", _hoisted_8, [
                              _createElementVNode("li", null, [
                                _createElementVNode("a", {
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.showDetailSuivi(props.row))
                                }, _cache[7] || (_cache[7] = [
                                  _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" Détails ", -1)
                                ]), 8, _hoisted_9)
                              ]),
                              (props.row.note_saved==0)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                                    _createVNode(_component_router_link, {
                                      class: "dropdown-item d-flex align-items-center",
                                      to: 'edit-delivery-note/' + props.row.id + '/' + props.row.note_ref
                                    }, {
                                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                                        _createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1),
                                        _createTextVNode(" Modifier ", -1)
                                      ])),
                                      _: 2,
                                      __: [8]
                                    }, 1032, ["to"])
                                  ]))
                                : _createCommentVNode("", true),
                              (props.row.note_total_parcel==0 && props.row.note_saved==0)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item d-flex align-items-center",
                                      href: "javascript:void(0);",
                                      onClick: ($event: any) => (_ctx.removeBL(props.row.id))
                                    }, _cache[9] || (_cache[9] = [
                                      _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" Supprimer ", -1)
                                    ]), 8, _hoisted_12)
                                  ]))
                                : _createCommentVNode("", true),
                              (props.row.note_saved==0 && props.row.note_total_parcel!=0)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item d-flex align-items-center",
                                      href: "javascript:void(0);",
                                      onClick: ($event: any) => (_ctx.saveBL(props.row.id))
                                    }, _cache[10] || (_cache[10] = [
                                      _createElementVNode("i", { class: "flaticon-diskette lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" Enregistrer ", -1)
                                    ]), 8, _hoisted_14)
                                  ]))
                                : _createCommentVNode("", true),
                              (props.row.note_saved!=0)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item d-flex align-items-center",
                                      href: "javascript:void(0);",
                                      onClick: ($event: any) => (_ctx.openBL(props.row.id))
                                    }, _cache[11] || (_cache[11] = [
                                      _createElementVNode("i", { class: "flaticon-unlock lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" Ouvrir ", -1)
                                    ]), 8, _hoisted_16)
                                  ]))
                                : _createCommentVNode("", true),
                              (props.row.note_total_parcel!=0)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item d-flex align-items-center",
                                      href: "javascript:void(0);",
                                      onClick: ($event: any) => (_ctx.getPDF(props.row))
                                    }, _cache[12] || (_cache[12] = [
                                      _createElementVNode("i", { class: "flaticon-printer lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" PDF ", -1)
                                    ]), 8, _hoisted_18)
                                  ]))
                                : _createCommentVNode("", true),
                              (props.row.note_total_parcel!=0 &&  props.row.note_saved == 1)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item d-flex align-items-center",
                                      href: "javascript:void(0);",
                                      onClick: ($event: any) => (_ctx.ticketsPDF(props.row))
                                    }, _cache[13] || (_cache[13] = [
                                      _createElementVNode("i", { class: "flaticon-menu lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" Tickets ", -1)
                                    ]), 8, _hoisted_20)
                                  ]))
                                : _createCommentVNode("", true),
                              (props.row.note_total_parcel!=0 &&  props.row.note_saved == 1)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item d-flex align-items-center",
                                      href: "javascript:void(0);",
                                      onClick: ($event: any) => (_ctx.tickets4PDF(props.row))
                                    }, _cache[14] || (_cache[14] = [
                                      _createElementVNode("i", { class: "flaticon-more-1 lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" Tickets 4*4 ", -1)
                                    ]), 8, _hoisted_22)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "loading"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.filters,
          offset: 9,
          onPaginate: _ctx.getRecords
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Informations"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_27, [
            (_ctx.noteBL && Object.keys(_ctx.noteBL).length != 0)
              ? (_openBlock(), _createBlock(_component_DetailsNote, {
                  key: 0,
                  noteBL: _ctx.noteBL,
                  getRecords: _ctx.getRecords,
                  type: true,
                  isOpen: _ctx.isOpen
                }, null, 8, ["noteBL", "getRecords", "isOpen"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}